import { Box, Flex, Grid, GridItem } from '@chakra-ui/react';
import { Image } from '@common/components/Image';

import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import currency from '@common/utility/currency';
import { formatDate } from '@common/utility/datetime';
import React, { useMemo } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { CURRENCY_OPTIONS } from '../../constants';
import { useStatementViewModel } from '../../models/StatementViewModel';

export const Header: React.FC = () => {
  const statementViewModel = useStatementViewModel();
  const investorAccountModel = useInvestorAccountModel();

  let accountNumber = '';
  const investorAccountNumberParts = investorAccountModel.investorAccount?.id.split('-');
  if (investorAccountNumberParts && investorAccountNumberParts.length > 0) {
    accountNumber = investorAccountNumberParts[investorAccountNumberParts?.length - 1].toUpperCase();
  }

  const investorAccount = investorAccountModel.investorAccount;
  const holdings = statementViewModel.statement?.holdings;
  const earnings = statementViewModel.statement?.activity?.earnings;

  const totals = useMemo(() => {
    let endValue = holdings?.totals.end_value ? parseFloat(holdings?.totals.end_value) : 0;
    if (isNaN(endValue)) endValue = 0;

    let startValue = holdings?.totals.start_value ? parseFloat(holdings?.totals.start_value) : 0;
    if (isNaN(startValue)) startValue = 0;

    const netEarnings = earnings?.totals.net_amount ? parseFloat(earnings?.totals.net_amount) : 0;

    return {
      earnings: currency.format(netEarnings, CURRENCY_OPTIONS),
      end: currency.format(endValue, CURRENCY_OPTIONS),
      start: currency.format(startValue, CURRENCY_OPTIONS),
    };
  }, [holdings?.totals.start_value, holdings?.totals.end_value]);

  return (
    <>
      <Image h="10px" image="logo-black" />{' '}
      <Flex mt="24px" justifyContent={'space-between'}>
        <Box>
          <TextBlock color="black" fontSize={'18px'} weight="bold">{`${formatDate(
            new Date(`${statementViewModel.month}-05`),
            'MMMM YYYY',
          )} Statement`}</TextBlock>
          <Box mt="20px">
            <TextBlock
              fontSize="inherit"
              weight="bold">{`${investorAccount?.individual_details?.first_name} ${investorAccount?.individual_details?.last_name}`}</TextBlock>
            <TextBlock fontSize="inherit">{investorAccount?.address}</TextBlock>
            {investorAccount?.address2 != null && <TextBlock fontSize="inherit">{investorAccount?.address2}</TextBlock>}
            <TextBlock fontSize="inherit">{`${investorAccount?.city}, ${investorAccount?.state} ${investorAccount?.zip} `}</TextBlock>
            <TextBlock fontSize="inherit"></TextBlock>
          </Box>
        </Box>
        <Flex flexDir={'column'} justifyContent="flex-end">
          <Grid
            minW="200px"
            borderRadius={'5px'}
            borderColor="gray.300"
            borderWidth={'1px'}
            borderStyle="solid"
            pt="12px"
            templateColumns={'1fr 1fr'}>
            <GridItem px="12px">
              <TextBlock fontSize="inherit">Account No.</TextBlock>
            </GridItem>

            <GridItem pr="12px">
              <TextBlock fontSize="inherit" weight="bold">
                {accountNumber}
              </TextBlock>
            </GridItem>

            <GridItem pt="14px" px="12px">
              <TextBlock fontSize="inherit">{'Starting Balance:'}</TextBlock>
            </GridItem>

            <GridItem pt="14px" pr="12px">
              <TextBlock fontSize="inherit">{totals.start}</TextBlock>
            </GridItem>

            <GridItem pb="14px" px="12px">
              <TextBlock fontSize="inherit">{'Earnings:'}</TextBlock>
            </GridItem>

            <GridItem pb="14px" pr="12px">
              <TextBlock fontSize="inherit">{totals.earnings}</TextBlock>
            </GridItem>

            <GridItem py="6px" px="12px" borderBottomLeftRadius={'4px'} backgroundColor={'gray.100'}>
              <TextBlock fontSize="inherit" weight={'bold'}>
                Ending Balance: <sup>3</sup>
              </TextBlock>
            </GridItem>

            <GridItem borderBottomRightRadius={'4px'} py="6px" pr="12px" backgroundColor={'gray.100'}>
              <TextBlock weight="bold" fontSize="inherit">
                {totals.end}
              </TextBlock>
            </GridItem>
          </Grid>
        </Flex>
      </Flex>
    </>
  );
};
